export const LIFECYCLE_STATUS_MAPPING = {
  new: { title: 'New' },
  accept_liability: { title: 'Accept liability' },
  duplicate: { title: 'Duplicate' },
  invalid: { title: 'Invalid' },
  missing_data: { title: 'Missing data' },
  error_skipped: { title: 'Error skipped' },
  invalid_reason_code: { title: 'Invalid reason code' },
  document_sent: { title: 'Document sent' },
  urgent: { title: 'Urgent' },
  ready_to_send: { title: 'Ready to send' },
  queued_to_send: { title: 'Queued to send' },
  ready_to_accept: { title: 'Ready to accept' },
  queued_to_accept: { title: 'Queued to send' },
  system_completed: { title: 'System Completed' },
  docsend_failed: { title: 'Document sent failure' }
}
